import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FifaSubscrieService {
  private emailSubscribeDialogSubject = new Subject<void>();

  // Observable to listen for events
  emailSubscribeDialogObservable$ = this.emailSubscribeDialogSubject.asObservable();

  // Method to trigger the dialog opening
  showEmailSubscribeDialog() {
    this.emailSubscribeDialogSubject.next();
  }
}
